import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-[#2d3239] bg-[#0a0b0d]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_dustsentinel-lx/artifacts/aggpk6vn_ChatGPT%20Image%20May%206%2C%202026%2C%2011_36_09%20AM%20%283%29.png"
                alt="DustSentinel"
                className="h-7 w-7 object-contain"
              />
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#f2f4f8]">
                DustSentinel
              </span>
            </div>
            <p className="text-sm text-[#8c9eb3] max-w-sm leading-relaxed">
              Mission-critical environmental assurance for lunar habitable systems.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-[#4b7399] mb-4">
              Navigation
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { label: "Product", path: "/product" },
                { label: "Applications", path: "/applications" },
                { label: "Technology", path: "/technology" },
                { label: "Why Dust Matters", path: "/why-dust-matters" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-[#8c9eb3] hover:text-[#f2f4f8] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-[#4b7399] mb-4">
              Inquiries
            </h4>
            <p className="text-sm text-[#8c9eb3] mb-2">
              For habitat integrators, rover developers, and lunar infrastructure teams.
            </p>
            <Link
              to="/contact"
              className="font-mono text-xs tracking-wider uppercase text-[#4b7399] hover:text-[#f2f4f8] transition-colors"
            >
              Request Technical Overview
            </Link>
          </div>
        </div>

        <div className="border-t border-[#2d3239] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-mono text-xs text-[#8c9eb3]">
            DustSentinel Environmental Systems Limited — Company No. 17220102
          </p>
          <p className="font-mono text-xs text-[#8c9eb3]">
            DustSentinel-LX Subsystem Platform
          </p>
        </div>
      </div>
    </footer>
  );
}
